import React, { useEffect } from "react";
import { store } from "../../../store/store";
import { ACL } from '../../../config/constants';
import { TicketDetailsTab } from './tabs/TicketDetailsTab';
import { hideNotification } from '../../../store/actions/notification';
import { NOTIFICATION_ERROR } from '../../../store/actions/types';

function TicketDetailsComponent(props) {
  const { ticket } = props;

  useEffect(() => {
    return () => {
      if (store.getState().notification.type === NOTIFICATION_ERROR) {
        store.dispatch(hideNotification());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const requestedTab = new URLSearchParams(props.location.search).get("tab");
  const shouldRenderDetails = ! requestedTab || requestedTab === 'ticket';

  if (! ACL.CLIENT.TICKETS.MANAGE.hasAccess() || ! shouldRenderDetails) {
    return null;
  }

  return <TicketDetailsTab ticket={ticket}/>;
}

export { TicketDetailsComponent };
